


// import React, { useState, useRef } from "react";
// import StepHeader from "./StepHeader";
// import Profilemangement from "./Profilemangement";
// import PreviewCard from "./PreviewCard";
// import ContactDetails from "./ContactDetails";
// import LicensesDocuments from "./LicensesDocuments";

// const EngineeringRegistration = () => {
//   const [step, setStep] = useState(1);
//   const previewRef = useRef(null);
//   const width = window.innerWidth;
//   const containerHeight =
//     width >= 1000 && width <= 1300 ? "350px" : "474px";
//   const [formData, setFormData] = useState({
//     goal: "",
//     campaignName: "",
//     subGoal: ""
//   });

//   const dynamicHeight =
//     window.innerWidth >= 1000 && window.innerWidth <= 1300
//       ? "45vh"
//       : "58vh";

//   const handleNext = () => {
//     if (step < 4) {
//       setStep((prev) => prev + 1);
//     }
//   };

//   const handleBack = () => {
//     if (step > 1) {
//       setStep((prev) => prev - 1);
//     }
//   };

//   const scrollToPreviewBottom = () => {
//     if (previewRef.current) {
//       previewRef.current.scrollTo({
//         top: previewRef.current.scrollHeight,
//         behavior: "smooth"
//       });
//     }
//   };

//   return (
//     <div style={{ padding: "20px", minHeight: "100vh" }}>

//       {/* 🔥 HEADER CLICK ENABLED */}
//       <StepHeader
//         currentStep={step}
//         onStepClick={(clickedStep) => setStep(clickedStep)}
//       />

//       <div style={{ display: "flex", gap: "20px" }}>

//         <div
//           style={{
//             flex: 2,
//             background: "#fff",
//             padding: "20px",
//             borderRadius: "12px",
//             boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
//             height:
//               window.innerWidth >= 1000 && window.innerWidth <= 1400
//                 ? "350px"
//                 : "474px",
//             overflow: "auto",
//             scrollbarWidth: "none",
//             marginTop: "20px"
//           }}
//         >
//           {step === 1 && (
//             <Profilemangement
//               formData={formData}
//               setFormData={setFormData}
//               onNext={handleNext}
//             />
//           )}

//           {step === 2 && (
//             <ContactDetails
//               formData={formData}
//               setFormData={setFormData}
//               onNext={handleNext}
//               onBack={handleBack}
//             />
//           )}

//           {step === 3 && (
//             <LicensesDocuments
//               formData={formData}
//               setFormData={setFormData}
//               onNext={handleNext}
//               onBack={handleBack}
//               onSubmitScroll={scrollToPreviewBottom}
//             />
//           )}

//           {step === 4 && (
//             <>
//               <div
//                 style={{

//                   height:
//                     window.innerWidth >= 1000 && window.innerWidth <= 1400
//                       ? "335px"
//                       : "450px",
//                   overflow: "auto",
//                   scrollbarWidth: "none",
//                 }}
//               >
//                 <PreviewCard formData={formData} onBack={handleBack} />


//               </div>
//             </>
//           )}
//         </div>

//       </div>
//     </div>
//   );
// };

// export default EngineeringRegistration;




import React, { useState, useRef, useEffect } from "react";
import StepHeader from "./StepHeader";
import Profilemangement from "./Profilemangement";
import PreviewCard from "./PreviewCard";
import ContactDetails from "./ContactDetails";
import LicensesDocuments from "./LicensesDocuments";
import EngineeringLocation from "./EngineeringLocation";
import EngineeringIntro from "./EngineeringIntro";
import { getEngineeringVendorById } from "../../../Service/Engineeringservicefil";
import { useLoader } from "../../../context/LoaderProvider";

const EngineeringRegistration = () => {
  const [step, setStep] = useState(1);
  const [showRegistration, setShowRegistration] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const previewRef = useRef(null);
  const { showLoader, hideLoader } = useLoader();
  
  const [formData, setFormData] = useState({
    // Step 1 - Company
    companyName: "",
    position: "",
    businessVertical: "",
    vendorType: "",
    
    // Step 2 - Contact
    contactName: "",
    phone: "",
    email: "",
    aadhar: "",
    aadharFile: null,
    aadharPreview: "",
    
    // Step 3 - Documents & Licenses
    gst: "",
    gstFile: null,
    gstFilePreview: "",
    pan: "",
    panFile: null,
    panFilePreview: "",
    tradeLicenseNo: "",
    tradeLicenseFile: null,
    tradeLicenseFilePreview: "",
    tradeStart: "",
    tradeEnd: "",
    labourLicenseNo: "",
    labourFile: null,
    labourFilePreview: "",
    labourStart: "",
    labourEnd: "",
    bankName: "",
    ifsc: "",
    accountNumber: "",
    passbookFile: null,
    passbookFilePreview: "",
    
    // Step 4 - Location
    latitude: "",
    longitude: "",
    fullAddress: "",
    doorNumber: "",
    addressLine: "",
    landMark: "",
    city: "",
    state: "",
    pincode: ""
  });

  // Check if user has already completed registration
  useEffect(() => {
    const checkRegistrationStatus = async () => {
      const vendorId = localStorage.getItem("vendorId");
      
      if (!vendorId) {
        setShowRegistration(false);
        setIsLoading(false);
        return;
      }

      try {
        showLoader();
        const data = await getEngineeringVendorById(vendorId);
        
        if (data && data.vendorId) {
          // Check if vendor has completed registration
          const hasCompletedRegistration = data.companyName || data.holderName;
          setShowRegistration(hasCompletedRegistration);
          
          // Populate existing data if available
          if (hasCompletedRegistration) {
            setFormData(prev => ({
              ...prev,
              // Company
              companyName: data.companyName || "",
              businessVertical: data.businessVertical || "ENGINEERING_SERVICE",
              position: data.position || "",
              vendorType: data.vendorType || "",
              
              // Contact
              contactName: data.holderName || "",
              phone: data.mobileNumber || "",
              email: data.email || "",
              aadhar: data.aadharNumber || "",
              aadharPreview: data.aadharPhotoFront || "",
              
              // Documents
              gst: data.gstNumber || "",
              gstFilePreview: data.gstImage || "",
              pan: data.panCardNumber || "",
              panFilePreview: data.panCard || "",
              tradeLicenseNo: data.tradeLicenseNumber || "",
              tradeLicenseFilePreview: data.tradeLicense || "",
              tradeStart: data.tradeLicenseStartDate || "",
              tradeEnd: data.tradeLicenseEndDate || "",
              labourLicenseNo: data.labourLicenseNumber || "",
              labourFilePreview: data.labourLicense || "",
              labourStart: data.labourStartDate || "",
              labourEnd: data.labourEndDate || "",
              bankName: data.bankName || "",
              ifsc: data.ifscCode || "",
              accountNumber: data.bankAccountNumber || "",
              passbookFilePreview: data.passbookImage || "",
              
              // Location
              latitude: data.latitude || "",
              longitude: data.longitude || "",
              doorNumber: data.doorNumber || "",
              addressLine: data.addressLine || "",
              landMark: data.landMark || "",
              city: data.city || "",
              state: data.state || "",
              pincode: data.pincode || "",
              fullAddress: data.fullAddress || ""
            }));
          }
        } else {
          setShowRegistration(false);
        }
      } catch (error) {
        console.error("Error checking registration status:", error);
        setShowRegistration(false);
      } finally {
        hideLoader();
        setIsLoading(false);
      }
    };

    checkRegistrationStatus();
  }, []);

  const handleBeginRegistration = () => {
    setShowRegistration(true);
    setStep(1);
  };

  const handleNext = () => {
    if (step < 5) {
      setStep((prev) => prev + 1);
    }
  };

  const handleBack = () => {
    if (step > 1) {
      setStep((prev) => prev - 1);
    }
  };

  const scrollToPreviewBottom = () => {
    if (previewRef.current) {
      previewRef.current.scrollTo({
        top: previewRef.current.scrollHeight,
        behavior: "smooth"
      });
    }
  };

  if (isLoading) {
    return (
      <div style={loadingContainer}>
        <div style={spinner}></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!showRegistration) {
    return <EngineeringIntro onBeginRegistration={handleBeginRegistration} />;
  }

  return (
    <div style={{ padding: "20px", minHeight: "100vh" ,margin:"0px 10%"}}>
      <StepHeader
        currentStep={step}
        onStepClick={(clickedStep) => setStep(clickedStep)}
      />

      <div style={{ display: "flex", gap: "20px" }}>
        <div
          style={{
            flex: 2,
            background: "#fff",
            padding: "20px",
            borderRadius: "12px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
            height: window.innerWidth >= 1000 && window.innerWidth <= 1400 ? "350px" : "474px",
            overflow: "auto",
            scrollbarWidth: "none",
            marginTop: "20px"
          }}
        >
          {step === 1 && (
            <Profilemangement
              formData={formData}
              setFormData={setFormData}
              onNext={handleNext}
            />
          )}

          {step === 2 && (
            <ContactDetails
              formData={formData}
              setFormData={setFormData}
              onNext={handleNext}
              onBack={handleBack}
            />
          )}

          {step === 3 && (
            <LicensesDocuments
              formData={formData}
              setFormData={setFormData}
              onNext={handleNext}
              onBack={handleBack}
              onSubmitScroll={scrollToPreviewBottom}
            />
          )}

          {step === 4 && (
            <EngineeringLocation
              formData={formData}
              setFormData={setFormData}
              onNext={handleNext}
              onBack={handleBack}
            />
          )}

          {step === 5 && (
            <div
              style={{
                height: window.innerWidth >= 1000 && window.innerWidth <= 1400
                  ? "335px"
                  : window.innerWidth < 1500 ? "70vh" : "65vh",
                overflow: "auto",
                scrollbarWidth: "none",
              }}
            >
              <PreviewCard formData={formData} onBack={handleBack} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EngineeringRegistration;

const loadingContainer = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "100vh",
  // background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
  color: "#fff"
};

const spinner = {
  width: "50px",
  height: "50px",
  border: "4px solid rgba(255, 255, 255, 0.3)",
  borderTop: "4px solid #fff",
  borderRadius: "50%",
  animation: "spin 1s linear infinite",
  marginBottom: "16px"
};

const spinStyle = document.createElement("style");
spinStyle.textContent = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
if (!document.querySelector("#engineering-spin-style")) {
  spinStyle.id = "engineering-spin-style";
  document.head.appendChild(spinStyle);
}